/*
 * First-order offer pop-up (founder 2026-09-02) — first-party, cookieless
 * (state lives in localStorage only after the visitor interacts), two arms:
 *
 *   standard — email → POST /apps/yutrients/offer/claim → 10% code
 *   spin     — email → claim (server picks 10/15/20) → wheel animates to
 *              the tier the server chose → code
 *
 * Then the browser subscribes the email to the Klaviyo list via the public
 * client API with popup_variant / first_order_code / first_order_tier
 * profile properties (same pattern as the footer form; never a private key).
 * Every exposure / close / submit / claim posts to /offer/event on the
 * beacon's session hash so arms are scored per session.
 *
 * Targeting mirrors the retired Klaviyo form: delay, URL exclusions, re-show
 * a day after close, never after a claim, devices, click outside to close.
 * Test flags: ?ytoffer=now (ignore delay + suppression), reset (clear
 * state), spin | standard (force arm), noklaviyo (skip the list subscribe).
 */
(function () {
  'use strict';
  var root = document.getElementById('yt-offer');
  if (!root) return;

  var cfg = {};
  try { cfg = JSON.parse(root.getAttribute('data-config') || '{}') || {}; } catch (e) { cfg = {}; }
  cfg.delay = Number(cfg.delay); if (isNaN(cfg.delay)) cfg.delay = 10;
  cfg.closedDays = Number(cfg.closedDays); if (isNaN(cfg.closedDays)) cfg.closedDays = 1;
  cfg.spinShare = Number(cfg.spinShare); if (isNaN(cfg.spinShare)) cfg.spinShare = 50;
  cfg.exclude = Array.isArray(cfg.exclude) ? cfg.exclude : ['cart', 'checkouts'];
  cfg.copy = cfg.copy || {};
  cfg.slices = Array.isArray(cfg.slices) && cfg.slices.length ? cfg.slices : [
    { label: '5% off', pct: 5 }, { label: '10% off', pct: 10 }, { label: '15% off', pct: 15 },
    { label: '5% off', pct: 5 }, { label: '10% off', pct: 10 }, { label: '15% off', pct: 15 }
  ];

  var KEY = 'yt_offer_v1';
  var flags = {};
  try {
    var q = new URLSearchParams(location.search).get('ytoffer');
    if (q) q.split(',').forEach(function (f) { flags[f.trim()] = true; });
  } catch (e) { /* no flags */ }

  var mem = {};
  function load() {
    if (flags.reset) { try { localStorage.removeItem(KEY); } catch (e) { /* noop */ } return {}; }
    try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch (e) { return mem; }
  }
  function save(s) { mem = s; try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) { /* private mode */ } }

  var state = load();
  var path = location.pathname.toLowerCase();
  var w = window.innerWidth;
  var device = w < 768 ? 'mobile' : (w < 1024 ? 'tablet' : 'desktop');

  function excluded() {
    for (var i = 0; i < cfg.exclude.length; i++) {
      var s = String(cfg.exclude[i] || '').trim().toLowerCase();
      if (s && path.indexOf(s) !== -1) return true;
    }
    return false;
  }

  if (!flags.now) {
    if (excluded()) return;
    if (state.claimed) return;
    if (state.closedAt && cfg.closedDays > 0 && Date.now() - state.closedAt < cfg.closedDays * 864e5) return;
    if (cfg.devices === 'desktop' && device === 'mobile') return;
    if (cfg.devices === 'mobile' && device !== 'mobile') return;
  }

  if (flags.spin) state.variant = 'spin';
  else if (flags.standard) state.variant = 'standard';
  if (state.variant !== 'spin' && state.variant !== 'standard') {
    state.variant = (Math.random() * 100 < cfg.spinShare) ? 'spin' : 'standard';
    state.assignedAt = Date.now();
  }
  save(state);
  var variant = state.variant;
  root.setAttribute('data-variant', variant);
  root.classList.add('yt-offer--' + variant);

  // ── elements ─────────────────────────────────────────────────────────
  var stepForm = root.querySelector('[data-yt-offer-step="form"]');
  var stepDone = root.querySelector('[data-yt-offer-step="done"]');
  var titleEl = root.querySelector('[data-yt-offer-title]');
  var subEl = root.querySelector('[data-yt-offer-sub]');
  var wheelWrap = root.querySelector('[data-yt-offer-wheelwrap]');
  var canvas = root.querySelector('.yt-offer__wheel');
  var form = root.querySelector('[data-yt-offer-form]');
  var input = form ? form.querySelector('input[type="email"]') : null;
  var cta = root.querySelector('[data-yt-offer-cta]');
  var errEl = root.querySelector('[data-yt-offer-error]');
  var codeEl = root.querySelector('[data-yt-offer-code]');
  var tierEl = root.querySelector('[data-yt-offer-tier]');
  var copyBtn = root.querySelector('[data-yt-offer-copy]');
  var goBtn = root.querySelector('[data-yt-offer-go]');

  var isSpin = variant === 'spin';
  if (titleEl) titleEl.textContent = isSpin ? (cfg.copy.titleB || 'Spin for your discount') : (cfg.copy.titleA || '10% off your first formula');
  if (subEl) subEl.textContent = isSpin ? (cfg.copy.subB || 'Every slice wins.') : (cfg.copy.sub || '');
  if (cta) cta.textContent = isSpin ? (cfg.copy.ctaB || 'Spin the wheel') : (cfg.copy.ctaA || 'Claim my 10%');
  if (isSpin && wheelWrap) wheelWrap.hidden = false;

  // ── beacon ───────────────────────────────────────────────────────────
  function consentState() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      var c = api && api.currentVisitorConsent && api.currentVisitorConsent();
      if (!c) return 'unknown';
      if (c.marketing === 'yes' || c.analytics === 'yes') return 'accepted';
      if (c.marketing === 'no' || c.analytics === 'no') return 'declined';
      return 'undecided';
    } catch (e) { return 'unknown'; }
  }
  function beacon(ev) {
    var p = JSON.stringify({ variant: variant, event: ev, path: location.pathname, device: device, consent: consentState() });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon('/apps/yutrients/offer/event', new Blob([p], { type: 'text/plain' }))) return;
    } catch (e) { /* fall through */ }
    try {
      fetch('/apps/yutrients/offer/event', { method: 'POST', body: p, headers: { 'Content-Type': 'text/plain' }, keepalive: true, credentials: 'same-origin' });
    } catch (e) { /* analytics never breaks the page */ }
  }

  // ── wheel ────────────────────────────────────────────────────────────
  var ctx = canvas && canvas.getContext ? canvas.getContext('2d') : null;
  var rot = 0;
  var SIZE = w < 380 ? 260 : 300;
  var dpr = Math.min(2, window.devicePixelRatio || 1);
  if (canvas) {
    canvas.width = SIZE * dpr;
    canvas.height = SIZE * dpr;
    canvas.style.width = SIZE + 'px';
    canvas.style.height = SIZE + 'px';
  }
  function drawWheel() {
    if (!ctx) return;
    var n = cfg.slices.length;
    var R = SIZE / 2;
    var rim = R - 6;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, SIZE, SIZE);
    ctx.save();
    ctx.translate(R, R);
    ctx.rotate(rot);
    var step = (2 * Math.PI) / n;
    var i, s, pct, a0, a1, mid;
    // Slices.
    for (i = 0; i < n; i++) {
      s = cfg.slices[i];
      pct = Number(s.pct);
      // Colour by tier: 5% light stone, 10% olive, 15% charcoal.
      a0 = i * step;
      a1 = a0 + step;
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.arc(0, 0, rim, a0, a1);
      ctx.closePath();
      ctx.fillStyle = pct >= 15 ? '#3c3c3b' : (pct >= 10 ? '#596948' : '#e9ede2');
      ctx.fill();
    }
    // Slice dividers + outer ring.
    ctx.strokeStyle = '#ffffff';
    ctx.lineWidth = 3;
    for (i = 0; i < n; i++) {
      a0 = i * step;
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(Math.cos(a0) * rim, Math.sin(a0) * rim);
      ctx.stroke();
    }
    ctx.beginPath();
    ctx.arc(0, 0, rim, 0, 2 * Math.PI);
    ctx.lineWidth = 4;
    ctx.stroke();
    // Labels: kept UPRIGHT whatever the wheel's rotation (they orbit as it
    // spins), so nothing ever reads upside down. Big percentage, small OFF.
    for (i = 0; i < n; i++) {
      s = cfg.slices[i];
      pct = Number(s.pct);
      mid = i * step + step / 2;
      ctx.save();
      ctx.rotate(mid);
      ctx.translate(rim * 0.62, 0);
      ctx.rotate(-(mid + rot));
      ctx.textAlign = 'center';
      ctx.fillStyle = pct >= 10 ? '#ffffff' : '#3c3c3b';
      ctx.textBaseline = 'alphabetic';
      ctx.font = '500 26px Oswald, "Arial Narrow", sans-serif';
      ctx.fillText(pct + '%', 0, 4);
      ctx.font = '500 11px Oswald, "Arial Narrow", sans-serif';
      ctx.fillText('OFF', 0, 18);
      ctx.restore();
    }
    ctx.restore();
    // Hub.
    ctx.beginPath();
    ctx.arc(R, R, 22, 0, 2 * Math.PI);
    ctx.fillStyle = '#ffffff';
    ctx.fill();
    ctx.beginPath();
    ctx.arc(R, R, 8, 0, 2 * Math.PI);
    ctx.fillStyle = '#3c3c3b';
    ctx.fill();
  }
  function spinTo(pct, done) {
    if (!ctx) { done(); return; }
    var n = cfg.slices.length;
    var candidates = [];
    for (var i = 0; i < n; i++) if (Number(cfg.slices[i].pct) === Number(pct)) candidates.push(i);
    if (!candidates.length) candidates = [0];
    var idx = candidates[Math.floor(Math.random() * candidates.length)];
    var step = (2 * Math.PI) / n;
    var centre = idx * step + step / 2;
    var jitter = (Math.random() - 0.5) * step * 0.6;
    // Pointer sits at the top (-90°): land the chosen slice's centre there.
    var target = -Math.PI / 2 - centre + jitter;
    var current = rot;
    var delta = (((target - current) % (2 * Math.PI)) + 2 * Math.PI) % (2 * Math.PI);
    var total = delta + 5 * 2 * Math.PI;
    var reduced = false;
    try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { /* noop */ }
    var dur = reduced ? 500 : 4200;
    var t0 = null;
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      rot = current + total;
      drawWheel();
      setTimeout(done, 400);
    }
    function frame(ts) {
      if (finished) return;
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      rot = current + total * e;
      drawWheel();
      if (p < 1) requestAnimationFrame(frame);
      else finish();
    }
    requestAnimationFrame(frame);
    // Background tabs pause requestAnimationFrame; never leave a claimed
    // code hidden behind a wheel that stopped animating.
    setTimeout(finish, dur + 1500);
  }

  // ── open / close ─────────────────────────────────────────────────────
  var opened = false;
  function open() {
    if (opened) return;
    opened = true;
    root.hidden = false;
    document.body.classList.add('yt-offer-open');
    // Photo column: load the image only now (it is display:none on mobile
    // and never needed by visitors who don't see the pop-up).
    var img = root.querySelector('.yt-offer__img');
    if (img && !img.getAttribute('src') && img.getAttribute('data-src')) img.src = img.getAttribute('data-src');
    if (isSpin) {
      drawWheel();
      // Redraw once Oswald is available so the labels don't stay in the fallback face.
      try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(drawWheel); } catch (e) { /* noop */ }
    }
    // Desktop only: focusing the field on a phone throws the keyboard up
    // over the pop-up before the visitor has read it.
    if (device !== 'mobile') { try { if (input) input.focus({ preventScroll: true }); } catch (e) { /* noop */ } }
    beacon('view');
  }
  function close() {
    if (root.hidden) return;
    root.hidden = true;
    document.body.classList.remove('yt-offer-open');
    if (!state.claimed) { state.closedAt = Date.now(); save(state); }
    beacon('close');
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-yt-offer-close]'), function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });
  if (goBtn) goBtn.addEventListener('click', function () {
    document.body.classList.remove('yt-offer-open');
  });

  // ── claim ────────────────────────────────────────────────────────────
  var busy = false;
  function showError(msg) {
    if (!errEl) return;
    errEl.textContent = msg;
    errEl.hidden = false;
  }
  function setBusy(on) {
    busy = on;
    if (cta) {
      cta.disabled = on;
      if (on) cta.textContent = isSpin ? 'Spinning…' : 'Claiming…';
      else cta.textContent = isSpin ? (cfg.copy.ctaB || 'Spin the wheel') : (cfg.copy.ctaA || 'Claim my 10%');
    }
  }
  function showSuccess(res) {
    if (stepForm) stepForm.hidden = true;
    if (stepDone) stepDone.hidden = false;
    if (codeEl) codeEl.textContent = res.code;
    if (tierEl) tierEl.textContent = res.tier_pct + '% off your first order';
    try { if (copyBtn) copyBtn.focus({ preventScroll: true }); } catch (e) { /* noop */ }
  }
  function subscribeKlaviyo(email, res) {
    if (flags.noklaviyo || !cfg.listId || !cfg.publicKey) return;
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'First-order pop-up (' + variant + ')',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  signup_source: 'first-order-popup',
                  popup_variant: variant,
                  popup_arm: isSpin ? 'Spin-to-win wheel' : 'Standard form',
                  first_order_code: res.code,
                  first_order_tier: res.tier_pct + '%',
                  first_order_claimed_at: new Date().toISOString()
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: cfg.listId } } }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(cfg.publicKey), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) {
      beacon(r.status === 202 || (r.status >= 200 && r.status < 300) ? 'klaviyo_ok' : 'klaviyo_fail');
    }).catch(function () { beacon('klaviyo_fail'); });
  }
  function onClaimed(email, res) {
    state.claimed = { code: res.code, tier: res.tier_pct, at: Date.now() };
    state.closedAt = null;
    save(state);
    beacon('claimed');
    subscribeKlaviyo(email, res);
    if (isSpin) spinTo(res.tier_pct, function () { showSuccess(res); });
    else showSuccess(res);
  }
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;
    var email = input ? (input.value || '').trim() : '';
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      showError('Please enter a valid email address.');
      return;
    }
    if (errEl) errEl.hidden = true;
    setBusy(true);
    beacon('submit');
    var hp = form.querySelector('input[name="website"]');
    fetch('/apps/yutrients/offer/claim', {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({ email: email, variant: variant, path: location.pathname, device: device, consent: consentState(), website: hp ? hp.value : '' }),
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().then(function (j) { return { status: r.status, body: j || {} }; });
    }).then(function (out) {
      if (!out.body.ok || !out.body.code) {
        var err = new Error('claim_failed');
        err.code = out.body.error || String(out.status);
        throw err;
      }
      onClaimed(email, out.body);
    }).catch(function (err) {
      setBusy(false);
      var code = err && err.code;
      showError(code === 'rate_limited' ? 'Too many tries from this connection. Please try again later.' :
        code === 'invalid_email' ? 'Please enter a valid email address.' :
          'Something went wrong. Please try again.');
      beacon('error');
    });
  });

  if (copyBtn) copyBtn.addEventListener('click', function () {
    var code = codeEl ? codeEl.textContent : '';
    function done() { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1800); }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done, done); return; }
    } catch (e) { /* fall through */ }
    try {
      var sel = window.getSelection(); var range = document.createRange();
      range.selectNodeContents(codeEl); sel.removeAllRanges(); sel.addRange(range);
      document.execCommand('copy'); done();
    } catch (e) { /* noop */ }
  });

  // ── schedule ─────────────────────────────────────────────────────────
  // 2026-09-21 audit: a plain timer fired the sheet 8.6–10.1s after load,
  // over a 105-second average session with a 58% bounce — i.e. on people
  // mid-first-scroll, before they had reached the price, behind a backdrop
  // that blocks every tap on the first screen. Intent beats a stopwatch:
  // whichever comes first of 35% scroll depth, exit intent, or the
  // configured delay as a backstop at 2.5x. The delay setting still works
  // and ?ytoffer=now still opens it immediately.
  var delayMs = flags.now ? 0 : Math.max(0, cfg.delay) * 1000;
  function schedule() {
    if (delayMs === 0) { open(); return; }
    var fired = false;
    function go() {
      if (fired) return; fired = true;
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onOut);
      clearTimeout(backstop);
      open();
    }
    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h >= 0.35) go();
    }
    function onOut(e) {
      // Leaving through the top of the window, mouse only — a touch device
      // has no exit intent, which is why scroll depth carries phones.
      if (!e.relatedTarget && e.clientY <= 0) go();
    }
    var backstop = setTimeout(go, delayMs * 2.5);
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('mouseout', onOut);
    onScroll();
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule);
})();

/* build 2026-09-02T16:52:33Z */
